import { NgModule } from '@angular/core';
import { DeviceListComponent } from './pages/device-list/device-list.component';
import { DeviceUpgradeComponent } from './pages/device-upgrade/device-upgrade.component';
import { FirmwareListComponent } from './pages/firmware-list/firmware-list.component';
import { FirmwareDetailPanelComponent } from './components/firmware-detail-panel/firmware-detail-panel.component';
import { CustomFormModule } from '@shared/custom-form/custom-form.module';
import { SharedModule } from '@shared/shared.module';
import { DeviceRoutingModule } from '.';
import { FirmwareRoutingModule } from './firmware-routing.module';

@NgModule({
    declarations: [DeviceListComponent, DeviceUpgradeComponent, FirmwareListComponent, FirmwareDetailPanelComponent],
    imports: [CustomFormModule, DeviceRoutingModule, FirmwareRoutingModule, SharedModule]
})
export class DeviceModule {}
